export enum ServiceTemplateId {
  MainNumber = 1,
  AnswerGroup = 2,
  Menu = 7,
  VipList = 9
}
